import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, of, tap } from 'rxjs';

import { environment } from '../../environments/environment';

export interface PortalPublicConfig {
  turnstile_site_key: string;
  turnstile_enabled: boolean;
  otp_required: boolean;
  merchant_portal_url: string;
}

const EMPTY_CONFIG: PortalPublicConfig = {
  turnstile_site_key: '',
  turnstile_enabled: false,
  otp_required: false,
  merchant_portal_url: '',
};

@Injectable({ providedIn: 'root' })
export class PublicConfigService {
  private readonly http = inject(HttpClient);

  readonly config = signal<PortalPublicConfig>(EMPTY_CONFIG);
  readonly loaded = signal(false);

  constructor() {
    this.refresh().subscribe();
  }

  refresh(): Observable<PortalPublicConfig | null> {
    return this.http.get<PortalPublicConfig>(`${environment.apiUrl}/auth/portal/public-config/`).pipe(
      tap((payload) => {
        this.config.set({ ...EMPTY_CONFIG, ...payload });
        this.loaded.set(true);
      }),
      catchError(() => {
        this.loaded.set(true);
        return of(null);
      }),
    );
  }
}
